import ApiEndpoints from "../../endpoints";
import type * as models from "./index.types.ts";
import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../../@bizkeytech/base/core";
import {CancelToken} from "axios";

/**@inheritDoc*/
export class OperatorController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Fetches the current employee profile from the server.
     *
     * @param token             The token of the operator.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async getCurrentProfile(token: string, cancelToken?: CancelToken): models.GetCurrentEmployeeProfileResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.operator.getCurrentProfile,
            cancelToken: cancelToken,
            headers: {
                Authorization: token,
            },
        });
    }
}


export type * from './index.types.ts';
export default OperatorController;